import React from "react";

import CeoSrc from "../../../assets/team/ceo-v6.png";
import CmoSrc from "../../../assets/team/cmo-v3.jpg";
import HrSrc from "../../../assets/team/hr-v7.png";
import CtoSrc from "../../../assets/team/cto-berl-baker.png";
import CfoSrc from "../../../assets/team/cfo-sean-chen.png";
import CooSrc from "../../../assets/team/coo-steve-tan.png";

const team = [
  { name: "Juan Carlos", role: "Chief Executive Officer", image: CeoSrc },
  { name: "Maria Callas", role: "Chief Marketing Officer", image: CmoSrc },
  { name: "Isla Rose", role: "Chief Technology Officer", image: CtoSrc },
  { name: "Sean Chen", role: "Chief Financial Officer", image: CfoSrc },
  { name: "Steve Tan", role: "Chief Operating Officer", image: CooSrc },
  { name: "Rafael Cruz", role: "Head of People & HR", image: HrSrc },
];

const AboutTeamSection = () => {
  return (
    <section className="section team-section">
      <div className="container">
        <div className="team-section-heading">
          <div>
            <p className="eyebrow">The people behind Lovapex</p>
            <h2>Built by people who care about better career outcomes.</h2>
          </div>
          <p>
            Our leadership brings together technology, people, product, finance,
            and growth expertise around one shared mission.
          </p>
        </div>

        <div className="team-grid">
          {team.map((member) => (
            <article className="team-card" key={member.name}>
              <img
                alt={`${member.name}, Lovapex Tech ${member.role}`}
                loading="lazy"
                src={member.image}
              />
              <div>
                <span>Lovapex Tech</span>
                <h3>{member.name}</h3>
                <p>{member.role}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutTeamSection;
